import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useI18n } from "@/i18n/I18nProvider";

// Password field with an accessible show/hide toggle. Hidden by default.
export const PasswordInput = forwardRef(({ className = "", testId, ...props }, ref) => {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);
  const label = t(visible ? "auth.hidePassword" : "auth.showPassword");
  return (
    <div className="relative">
      <Input ref={ref} type={visible ? "text" : "password"} data-testid={testId} autoCapitalize="none"
        autoCorrect="off" spellCheck={false} className={`pr-12 ${className}`} {...props} />
      <button type="button" onClick={() => setVisible((v) => !v)} aria-label={label} title={label}
        aria-pressed={visible} data-testid={testId ? `${testId}-toggle` : undefined}
        className="absolute right-1 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-md text-gray-500 transition-colors hover:bg-gray-100 hover:text-[#000B45] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FEB601]">
        {visible ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
      </button>
    </div>
  );
});
PasswordInput.displayName = "PasswordInput";
